import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColumnWidthPersistenceService {

  getSavedColumnWidths(storageKey: string): Record<string, number> {
      const saved = localStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : {};
  }

  saveColumnWidth(storageKey: string, columnId: string, width: number): void {
      const savedWidths = this.getSavedColumnWidths(storageKey);
      savedWidths[columnId] = width;
      localStorage.setItem(storageKey, JSON.stringify(savedWidths));
  }

  getColumnWidth(storageKey: string, columnId: string, defaultWidth: number): number {
    const savedWidths = this.getSavedColumnWidths(storageKey);
    return savedWidths[columnId] || defaultWidth;
  }

  createColumnResizedHandler(storageKey: string): (params: any) => void {
    return (params: any) => {
      if (params.source !== 'sizeColumnsToFit' && 
          params.source !== 'autosizeColumns' && 
          params.column) {
        this.saveColumnWidth(storageKey, params.column.getColId(), params.column.getActualWidth());
      }
    };
  }
} 